import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ValidateInputs } from "../../helper/helper";

const AddFaq = () => {
  const [formData, setFormData] = useState({
    question: "",
    answer: "",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    const updatedInputs = ValidateInputs(name, value, errors);
    setErrors(updatedInputs);
  };

  // const validateForm = () => {
  //   const newErrors = {};

  //   Object.keys(formData).forEach((key) => {
  //     const value = formData[key];
  //     if (!value.trim()) {
  //       newErrors[key] = `${
  //         key.charAt(0).toUpperCase() + key.slice(1)
  //       } is required`;
  //     } else if (value.length > 100) {
  //       newErrors[key] = `${
  //         key.charAt(0).toUpperCase() + key.slice(1)
  //       } not more then 100 characters`;
  //     }
  //   });

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.question.trim()) {
      newErrors.question = "Question is required";
    } else if (formData.question.length > 100) {
      newErrors.question = "Question not more then 100 characters";
    } else if (!formData.answer.trim()) {
      newErrors.answer = "Answer is required";
    } else if (formData.answer.length > 1000) {
      newErrors.answer = "Answer not more then 1000 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${process.env.REACT_APP_API_URL}/faq/add`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("FAQ added successfully!");
      navigate("/faq");
    } catch (error) {
      console.error("Error adding faq:", error);
      toast.error("Failed to add faq. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">FAQ Management</h1>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-primary">
                  <form id="quickForm" onSubmit={handleSubmit}>
                    <div className="card-body">
                      <>
                        <div className="form-group">
                          <label htmlFor="question">Question</label>
                          <input
                            type="text"
                            name="question"
                            className={`form-control ${errors.question ? "is-invalid" : ""
                              }`}
                            value={formData.question}
                            onChange={handleChange}
                            placeholder="Enter question"
                          // maxLength={200}
                          />
                          {errors.question && (
                            <div className="invalid-feedback">
                              {errors.question}
                            </div>
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="answer">Answer</label>
                          <textarea
                            type="text"
                            name="answer"
                            className={`form-control ${errors.answer ? "is-invalid" : ""
                              }`}
                            value={formData.answer}
                            onChange={handleChange}
                            placeholder="Enter answer"
                            style={{ height: "100px" }}
                          // maxLength={500}
                          />
                          {errors.answer && (
                            <div className="invalid-feedback">
                              {errors.answer}
                            </div>
                          )}
                        </div>
                      </>
                    </div>
                    <div className="card-footer">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isLoading}
                        style={{
                          opacity: isLoading ? 0.7 : 1,
                          cursor: isLoading ? 'not-allowed' : 'pointer'
                        }}
                      >
                        {isLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                            Adding...
                          </>
                        ) : (
                          'Add'
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddFaq;
